import common from './common.json';
import auth from './auth.json';
import onboarding from './onboarding.json';
import questionnaire from './questionnaire.json';
import feed from './feed.json';
import workout from './workout.json';
import profile from './profile.json';
import privacyPolicy from './privacy-policy.json';
import confirmPopup from './confirm-popup.json';
import chat from './chat.json';
import alerts from './alerts.json';
import post from './post.json';
import routine from './routine.json';
import group from './group.json';
import plan from './plan.json';
import gamification from './gamification.json';
import leaderboard from './leaderboard.json';
import privacyConsents from './privacy-consents.json';
import age from './age.json';

export const en = {
  ...common,
  ...auth,
  ...onboarding,
  ...questionnaire,
  ...feed,
  ...workout,
  ...profile,
  ...privacyPolicy,
  ...confirmPopup,
  ...chat,
  ...alerts,
  ...post,
  ...routine,
  ...group,
  ...plan,
  ...gamification,
  ...leaderboard,
  ...privacyConsents,
  ...age,
};
